import React from "react";

import PropTypes from "prop-types";

import FilterGroup from "./FilterGroup";
import styles from "./styles.css";

const SidebarFilters = ({ filters, onFilterChange, filterConfig }) => {
	const handleGroupChange = (key, values) => {
		onFilterChange({ ...filters, [key]: values });
	};

	return (
		<div className={styles.filtersGroup}>
			{filterConfig.map(config => (
				<FilterGroup
					key={config.key}
					label={config.label}
					options={config.options}
					selectedValues={filters[config.key]}
					onChange={values => handleGroupChange(config.key, values)}
				/>
			))}
		</div>
	);
};

SidebarFilters.propTypes = {
	filters: PropTypes.object.isRequired,
	onFilterChange: PropTypes.func.isRequired,
	filterConfig: PropTypes.arrayOf(PropTypes.shape({
		key: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		options: PropTypes.arrayOf(PropTypes.shape({
			value: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		})).isRequired,
	})).isRequired,
};

export default SidebarFilters;
